import { alElektronikEndpoints } from './alElektronikEndpoints';
import { alfatecEndpoints } from './alfatecEndpoints';
import { arrowEndpoints } from './arrowEndpoints';
import { atlantikNetworxxEndpoints } from './atlantikNetworxxEndpoints';
import { avnetAbacusV3Endpoints } from './avnetAbacusV3Endpoints';
import { avnetEbvV3Endpoints } from './avnetEbvV3Endpoints';
import { avnetSilicaV3Endpoints } from './avnetSilicaV3Endpoints';
import { avnetUsaV3Endpoints } from './avnetUsaV3Endpoints';
import { blumeEndpoints } from './blumeEndpoints';
import { bossardEndpoints } from './bossardEndpoints';
import { buerklinEndpoints } from './buerklinEndpoints';
import { corestaffEndpoints } from './corestaffEndpoints';
import { digikeyEndpoints } from './digikeyEndpoints';
import { digikeyV4Endpoints } from './digikeyV4Endpoints';
import { ecomalEndpoints } from './ecomalEndpoints';
import { element14Endpoints } from './element14Endpoints';
import { eveEndpoints } from './eveEndpoints';
import { farnellEndpoints } from './farnellEndpoints';
import { futureEndpoints } from './futureEndpoints';
import { greenchipsEndpoints } from './greenchipsEndpoints';
import { gudecoEndpoints } from './gudecoEndpoints';
import { heilindEndpoints } from './heilindEndpoints';
import { hexachipEndpoints } from './hexachipEndpoints';
import { ichubEndpoints } from './ichubEndpoints';
import { ineltroEndpoints } from './ineltroEndpoints';
import { kruseEndpoints } from './kruseEndpoints';
import { lcscEndpoints } from './lcscEndpoints';
import { lcscV3Endpoints } from './lcscV3Endpoints';
import { masterElectronicsEndpoints } from './masterElectronicsEndpoints';
import { mevEndpoints } from './mevEndpoints';
import { mouserEndpoints } from './mouserEndpoints';
import { myArrowEndpoints } from './myArrowEndpoints';
import { newarkEndpoints } from './newarkEndpoints';
import { onlineComponentsEndpoints } from './onlineComponentsEndpoints';
import { pcbManufacturersEndpoints } from './pcbManufacturersEndpoints';
import { questComponentsEndpoints } from './questComponentsEndpoints';
import { rapidElectronicsEndpoints } from './rapidElectronicsEndpoints';
import { rmComponentsEndpoints } from './rmComponentsEndpoints';
import { rochesterEndpoints } from './rochesterEndpoints';
import { rsComponentsEndpoints } from './rsComponentsEndpoints';
import { rutronikEndpoints } from './rutronikEndpoints';
import { samtecEndpoints } from './samtecEndpoints';
import { schukatEndpoints } from './schukatEndpoints';
import { siliconExpertEndpoints } from './siliconExpertEndpoints';
import { sosElectronicEndpoints } from './sosElectronicEndpoints';
import { sourcengineEndpoints } from './sourcengineEndpoints';
import { telconaEndpoints } from './telconaEndpoints';
import { tiEndpoints } from './tiEndpoints';
import { tmeEndpoints } from './tmeEndpoints';
import { trustedPartsEndpoints } from './trustedPartsEndpoints';
import { ttiEndpoints } from './ttiEndpoints';
import { unikeyEndpoints } from './unikeyEndpoints';
import { venkelEndpoints } from './venkelEndpoints';
import { weltronEndpoints } from './weltronEndpoints';
import { winsourceEndpoints } from './winsourceEndpoints';
import { wittigEndpoints } from './wittigEndpoints';
import { wuerthEisosEndpoints } from './wuerthEisosEndpoints';

export const thirdPartyEndpoints = {
    ...alElektronikEndpoints,
    ...alfatecEndpoints,
    ...atlantikNetworxxEndpoints,
    ...arrowEndpoints,
    ...avnetAbacusV3Endpoints,
    ...avnetSilicaV3Endpoints,
    ...avnetEbvV3Endpoints,
    ...avnetUsaV3Endpoints,
    ...blumeEndpoints,
    ...bossardEndpoints,
    ...buerklinEndpoints,
    ...digikeyEndpoints,
    ...digikeyV4Endpoints,
    ...ecomalEndpoints,
    ...element14Endpoints,
    ...eveEndpoints,
    ...farnellEndpoints,
    ...futureEndpoints,
    ...greenchipsEndpoints,
    ...gudecoEndpoints,
    ...ineltroEndpoints,
    ...kruseEndpoints,
    ...lcscEndpoints,
    ...lcscV3Endpoints,
    ...masterElectronicsEndpoints,
    ...sourcengineEndpoints,
    ...mevEndpoints,
    ...mouserEndpoints,
    ...myArrowEndpoints,
    ...newarkEndpoints,
    ...corestaffEndpoints,
    ...onlineComponentsEndpoints,
    ...pcbManufacturersEndpoints,
    ...questComponentsEndpoints,
    ...rmComponentsEndpoints,
    ...rapidElectronicsEndpoints,
    ...rochesterEndpoints,
    ...rsComponentsEndpoints,
    ...rutronikEndpoints,
    ...samtecEndpoints,
    ...schukatEndpoints,
    ...siliconExpertEndpoints,
    ...telconaEndpoints,
    ...tiEndpoints,
    ...tmeEndpoints,
    ...trustedPartsEndpoints,
    ...ttiEndpoints,
    ...unikeyEndpoints,
    ...weltronEndpoints,
    ...venkelEndpoints,
    ...wuerthEisosEndpoints,
    ...sosElectronicEndpoints,
    ...winsourceEndpoints,
    ...heilindEndpoints,
    ...hexachipEndpoints,
    ...ichubEndpoints,
    ...wittigEndpoints,
};
